import { KeypadContext } from '@3plearning/question-components-library';
import React, { useContext } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import Keypad from './keypad/keypad';
import css from './conquest.scss';
import Qtc from './qtc/qtc';
import QtcCorrectAnswer from './qtc-correct-answer/qtc-correct-answer';
import FlagToggle from '../flag-toggle/flag-toggle';
import TtsController from './tts/tts-controller';

const Conquest = ({ readAloudConfig }) => {
  const {
    keypadRef, questionBodyRef
  } = useContext(KeypadContext);

  return (
    <Box className={css.activity}>
      <Keypad />
      <FlagToggle className={css['flag-toggle']} />
      <TtsController readAloudConfig={readAloudConfig} />
      <Box className={css['inner-scroll']} id={'new-content-container'} ref={questionBodyRef}>
        <Qtc
          keypadRef={keypadRef}
          readAloudConfig={readAloudConfig}
        />
        <QtcCorrectAnswer />
      </Box>
    </Box>
  );
};

Conquest.propTypes = {
  readAloudConfig: PropTypes.object.isRequired
};

export default Conquest;
